module.exports = __webpack_public_path__ + "img/14-1.e8b2a5ee.svg";